import { Component, HostBinding, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'tded-footer',
    templateUrl: 'footer.component.html',
    standalone: false
})

export class FooterComponent implements OnInit {
    currentYear: number = new Date().getFullYear();

    ngOnInit() {
        if (sessionStorage.getItem('version')) {
            console.log('App version', environment.version);
        }
    }
}
